"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _fr = _interopRequireDefault(require("react-intl/locale-data/fr"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

(0, _reactIntl.addLocaleData)(_fr.default);

var withIntl = function withIntl(WrappedComponent) {
  return function (props) {
    return _react.default.createElement(_reactIntl.IntlProvider, {
      locale: navigator.language
    }, _react.default.createElement(WrappedComponent, props));
  };
};

var _default = withIntl;
exports.default = _default;